<template>
    <div
        :class="'curso-card '+'gtm-'+curso.guid"
        @click="$emit('click')">
        <img class="curso-card-image"
            :alt="'Imagen ' + curso.categoria"
            :src="require('@/assets/galerias/foto_generica.jpg')" >
        <div class="curso-card-info">
            <div class="curso-card-subtitle"
                v-html="curso.categoria + ' con'">
            </div>
            <div class="curso-card-title"
                v-html="curso.autor">
            </div>
        </div>
    </div>
</template>

<script>
//v-if="show_curso>=curso.posicion"
export default {
	props: ["curso","show_curso"]
};
</script>

